import React, { lazy } from "react";

import { VerificationService } from "../../lib/types/types";

import { ExperimentComponent } from "../FeatureFlags/ExperimentComponent/ExperimentComponent";

const Default = lazy(() => import("./DefaultStepDocUploadComponent"));
const Redesign = lazy(() => import("./RedesignStepDocUploadComponent"));

interface StepDocUploadProps {
  verificationService: VerificationService;
}

export const StepDocUploadComponent = ({ verificationService }: StepDocUploadProps) => (
  <ExperimentComponent
    flag="doc-upload-redesign"
    segments={["student"]}
    Default={Default}
    Experiment={Redesign}
    props={{ verificationService }}
  />
);
